export enum RowType {
    GENERIC = 0,
    DEVELOPMENT = 1,
    PRODUCTION = 2,
    ADHOC = 3,
}
